import "./footer.css";
// import logo from "assets/images/others/logo.png"
// import posterLogo from "assets/videos/poster_logo2.PNG"
// import logoVideo from "assets/videos/logo2.mp4"
import logoGif from "assets/videos/logo2.gif"

const Footer = () => {

  return (
    <footer className="footer">
      <div className="container ft-top-sec row">
        <div className="infos">
          <div className="picto">
            <img src={logoGif} alt="Meta Masks NFT" />
            {/* <video loop muted autoPlay poster={posterLogo}>
              <source src={logoVideo} />
            </video> */}
          </div>
        </div>
        <div className="f-right row ">
          <div className="social row">
            <div className="link">
              <a
                href="https://www.instagram.com/metamasksnft/"
                target="_blank" rel="noopener noreferrer"
                className="insta row"
              >.</a>
            </div>
            <div className="link">
              <a
                href="https://mobile.twitter.com/metamasksnft"
                target="_blank" rel="noopener noreferrer"
                className="twitter row"
              >.</a>
            </div>
            <div className="link">
              <a
                href="https://discord.gg/metamasksnft"
                target="_blank" rel="noopener noreferrer"
                className="discord row"
              >.</a>
            </div>
            <div className="link">
              <a
                href="https://linktr.ee/MetaMasksNFT"
                target="_blank" rel="noopener noreferrer"
                className="linktree row"
              >.</a>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <p className="copyright">©2021 &nbsp; Meta Masks NFT</p>
      </div>
    </footer>
  );
};

export default Footer;
